export default "__VITE_ASSET__52be82de__"